import { Trans } from 'react-i18next';

import { Survey } from '@dreryk/egabinet-survey-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { ModalConfirmExitConfig } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../translations';

import { PreInterviewUpdateFormBean } from './PreInterviewUpdateForm';

export const preInterviewModalConfirmExitConfig = (isDirty: boolean): ModalConfirmExitConfig => ({
   enabled: isDirty,
   cancelButtonLabel: commonTranslationKeys.cancel,
   confirmationButtonLabel: appointmentsTranslationKeys.preInterview.modalConfirmExit.confirm,
   content: (
      <Trans
         i18nKey={appointmentsTranslationKeys.preInterview.modalConfirmExit.content}
         components={{ bold: <strong /> }}
      />
   ),
});

export const formInitializer = (preInterview: Survey) => (): PreInterviewUpdateFormBean => {
   const preInterviewFormValues: PreInterviewUpdateFormBean = {};

   preInterview.answers.forEach(({ content, questionId }) => {
      preInterviewFormValues[questionId] = content;
   });

   return preInterviewFormValues;
};
